export const baseRetailerURL = process.env.REACT_APP_RETAILER_PORTAL_ROUTE as string;